/**
 * Do not edit this file manually!
 *
 * It is generated by scripts/dev/generate_fontawesome_manifest.rb
 * Use something like class="fa-solid fa-star" in a view/template/component and rerun the script
 */

import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
import {
  faAdjust as faSolidAdjust,
  faAlignJustify as faSolidAlignJustify,
  faAngleDoubleDown as faSolidAngleDoubleDown,
  faAngleDoubleLeft as faSolidAngleDoubleLeft,
  faAngleDoubleRight as faSolidAngleDoubleRight,
  faAngleDoubleUp as faSolidAngleDoubleUp,
  faAngleLeft as faSolidAngleLeft,
  faAngleRight as faSolidAngleRight,
  faArchive as faSolidArchive,
  faArrowCircleUp as faSolidArrowCircleUp,
  faArrowDown as faSolidArrowDown,
  faArrowLeft as faSolidArrowLeft,
  faArrowRight as faSolidArrowRight,
  faArrows as faSolidArrows,
  faArrowsUpDownLeftRight as faSolidArrowsUpDownLeftRight,
  faAt as faSolidAt,
  faBan as faSolidBan,
  faBarChart as faSolidBarChart,
  faBars as faSolidBars,
  faBold as faSolidBold,
  faBook as faSolidBook,
  faBug as faSolidBug,
  faBullhorn as faSolidBullhorn,
  faCalendar as faSolidCalendar,
  faCaretDown as faSolidCaretDown,
  faCaretLeft as faSolidCaretLeft,
  faCaretRight as faSolidCaretRight,
  faCertificate as faSolidCertificate,
  faCheck as faSolidCheck,
  faCheckSquare as faSolidCheckSquare,
  faChevronCircleDown as faSolidChevronCircleDown,
  faChevronDown as faSolidChevronDown,
  faChevronRight as faSolidChevronRight,
  faChevronUp as faSolidChevronUp,
  faCircle as faSolidCircle,
  faCircleInfo as faSolidCircleInfo,
  faCirclePlus as faSolidCirclePlus,
  faCircleQuestion as faSolidCircleQuestion,
  faClone as faSolidClone,
  faCloudDownload as faSolidCloudDownload,
  faCode as faSolidCode,
  faCodeFork as faSolidCodeFork,
  faCoffee as faSolidCoffee,
  faCog as faSolidCog,
  faCogs as faSolidCogs,
  faColumns as faSolidColumns,
  faCompress as faSolidCompress,
  faEllipsis as faSolidEllipsis,
  faEllipsisH as faSolidEllipsisH,
  faEnvelope as faSolidEnvelope,
  faExclamation as faSolidExclamation,
  faExpand as faSolidExpand,
  faExternalLink as faSolidExternalLink,
  faEye as faSolidEye,
  faEyeSlash as faSolidEyeSlash,
  faFile as faSolidFile,
  faFileCsv as faSolidFileCsv,
  faFileExcel as faSolidFileExcel,
  faFilter as faSolidFilter,
  faFlag as faSolidFlag,
  faFlagCheckered as faSolidFlagCheckered,
  faFolder as faSolidFolder,
  faFolderOpen as faSolidFolderOpen,
  faFont as faSolidFont,
  faGears as faSolidGears,
  faGlobe as faSolidGlobe,
  faGripDots as faSolidGripDots,
  faHashtag as faSolidHashtag,
  faHeader as faSolidHeader,
  faHome as faSolidHome,
  faImage as faSolidImage,
  faInfoCircle as faSolidInfoCircle,
  faItalic as faSolidItalic,
  faLink as faSolidLink,
  faLinkSlash as faSolidLinkSlash,
  faList as faSolidList,
  faListAlt as faSolidListAlt,
  faListOl as faSolidListOl,
  faLock as faSolidLock,
  faMailbox as faSolidMailbox,
  faMessageQuote as faSolidMessageQuote,
  faMessageXmark as faSolidMessageXmark,
  faPaperclip as faSolidPaperclip,
  faPencil as faSolidPencil,
  faPipe as faSolidPipe,
  faPlay as faSolidPlay,
  faPlus as faSolidPlus,
  faPlusCircle as faSolidPlusCircle,
  faPrint as faSolidPrint,
  faQuestion as faSolidQuestion,
  faQuestionCircle as faSolidQuestionCircle,
  faQuoteLeft as faSolidQuoteLeft,
  faRefresh as faSolidRefresh,
  faReply as faSolidReply,
  faReplyAll as faSolidReplyAll,
  faRss as faSolidRss,
  faSave as faSolidSave,
  faSearch as faSolidSearch,
  faShare as faSolidShare,
  faShield as faSolidShield,
  faSort as faSolidSort,
  faSortAsc as faSolidSortAsc,
  faSortDesc as faSolidSortDesc,
  faSortDown as faSolidSortDown,
  faSortNumericAsc as faSolidSortNumericAsc,
  faSortUp as faSolidSortUp,
  faSpaceShuttle as faSolidSpaceShuttle,
  faSpinner as faSolidSpinner,
  faSquare as faSolidSquare,
  faSquareO as faSolidSquareO,
  faStar as faSolidStar,
  faStepBackward as faSolidStepBackward,
  faStepForward as faSolidStepForward,
  faTag as faSolidTag,
  faTags as faSolidTags,
  faThumbsUp as faSolidThumbsUp,
  faThumbtack as faSolidThumbtack,
  faTimes as faSolidTimes,
  faTimesCircle as faSolidTimesCircle,
  faToggleOff as faSolidToggleOff,
  faToggleOn as faSolidToggleOn,
  faTrash as faSolidTrash,
  faUnlock as faSolidUnlock,
  faUnlockAlt as faSolidUnlockAlt,
  faUser as faSolidUser,
  faUserCircle as faSolidUserCircle,
  faUserMinus as faSolidUserMinus,
  faUserPlus as faSolidUserPlus,
  faUserSecret as faSolidUserSecret,
  faUserTimes as faSolidUserTimes,
  faUserXmark as faSolidUserXmark,
  faUsers as faSolidUsers,
  faXmark as faSolidXmark,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faDailymotion as faBrandsDailymotion,
  faDeviantart as faBrandsDeviantart,
  faFacebook as faBrandsFacebook,
  faFlickr as faBrandsFlickr,
  faInstagram as faBrandsInstagram,
  faKickstarter as faBrandsKickstarter,
  faMicrosoft as faBrandsMicrosoft,
  faSlideshare as faBrandsSlideshare,
  faSoundcloud as faBrandsSoundcloud,
  faSpotify as faBrandsSpotify,
  faTwitter as faBrandsTwitter,
  faVimeo as faBrandsVimeo,
  faWebAwesome as faBrandsWebAwesome,
  faYoutube as faBrandsYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faAlignCenter as faRegularAlignCenter,
  faAlignLeft as faRegularAlignLeft,
  faAlignRight as faRegularAlignRight,
  faAngleLeft as faRegularAngleLeft,
  faAngleRight as faRegularAngleRight,
  faArrowDownToBracket as faRegularArrowDownToBracket,
  faArrowLeft as faRegularArrowLeft,
  faArrows as faRegularArrows,
  faArrowsRepeat as faRegularArrowsRepeat,
  faArrowsUpDownLeftRight as faRegularArrowsUpDownLeftRight,
  faBars as faRegularBars,
  faBell as faRegularBell,
  faBold as faRegularBold,
  faBolt as faRegularBolt,
  faBookmark as faRegularBookmark,
  faBoxArchive as faRegularBoxArchive,
  faBullhorn as faRegularBullhorn,
  faCalendar as faRegularCalendar,
  faCalendarDay as faRegularCalendarDay,
  faCalendarPlus as faRegularCalendarPlus,
  faCalendarRange as faRegularCalendarRange,
  faCarSide as faRegularCarSide,
  faChartColumn as faRegularChartColumn,
  faChartSimple as faRegularChartSimple,
  faCheck as faRegularCheck,
  faCheckCircle as faRegularCheckCircle,
  faCheckSquare as faRegularCheckSquare,
  faChevronDown as faRegularChevronDown,
  faChevronUp as faRegularChevronUp,
  faCircle as faRegularCircle,
  faCircleCheck as faRegularCircleCheck,
  faCircleInfo as faRegularCircleInfo,
  faCircleNotch as faRegularCircleNotch,
  faCirclePlay as faRegularCirclePlay,
  faCirclePlus as faRegularCirclePlus,
  faCircleUser as faRegularCircleUser,
  faClipboard as faRegularClipboard,
  faClipboardList as faRegularClipboardList,
  faClock as faRegularClock,
  faClone as faRegularClone,
  faCloudDownload as faRegularCloudDownload,
  faCloudUpload as faRegularCloudUpload,
  faComment as faRegularComment,
  faCommentDots as faRegularCommentDots,
  faCommentSlash as faRegularCommentSlash,
  faComments as faRegularComments,
  faCompass as faRegularCompass,
  faComputerClassic as faRegularComputerClassic,
  faDesktop as faRegularDesktop,
  faEarthEurope as faRegularEarthEurope,
  faEdit as faRegularEdit,
  faEllipsis as faRegularEllipsis,
  faEllipsisH as faRegularEllipsisH,
  faEllipsisVertical as faRegularEllipsisVertical,
  faEnvelope as faRegularEnvelope,
  faExchange as faRegularExchange,
  faEye as faRegularEye,
  faFaceSmile as faRegularFaceSmile,
  faFile as faRegularFile,
  faFileCode as faRegularFileCode,
  faFileExcel as faRegularFileExcel,
  faFilePowerpoint as faRegularFilePowerpoint,
  faFileText as faRegularFileText,
  faFileWord as faRegularFileWord,
  faFiles as faRegularFiles,
  faFilter as faRegularFilter,
  faFlask as faRegularFlask,
  faFloppyDisk as faRegularFloppyDisk,
  faFolder as faRegularFolder,
  faFolderOpen as faRegularFolderOpen,
  faGift as faRegularGift,
  faHand as faRegularHand,
  faHandshake as faRegularHandshake,
  faHeadphones as faRegularHeadphones,
  faHouse as faRegularHouse,
  faImage as faRegularImage,
  faInbox as faRegularInbox,
  faItalic as faRegularItalic,
  faKeyboard as faRegularKeyboard,
  faLink as faRegularLink,
  faList as faRegularList,
  faListUl as faRegularListUl,
  faLocationDot as faRegularLocationDot,
  faLock as faRegularLock,
  faMailbox as faRegularMailbox,
  faMapLocation as faRegularMapLocation,
  faMapLocationDot as faRegularMapLocationDot,
  faMessages as faRegularMessages,
  faMinusCircle as faRegularMinusCircle,
  faMobile as faRegularMobile,
  faNewspaper as faRegularNewspaper,
  faPaperclipVertical as faRegularPaperclipVertical,
  faPenNib as faRegularPenNib,
  faPenToSquare as faRegularPenToSquare,
  faPencil as faRegularPencil,
  faPencilSquare as faRegularPencilSquare,
  faPhone as faRegularPhone,
  faPipe as faRegularPipe,
  faPlus as faRegularPlus,
  faPlusCircle as faRegularPlusCircle,
  faPlusSquare as faRegularPlusSquare,
  faPowerOff as faRegularPowerOff,
  faPuzzlePiece as faRegularPuzzlePiece,
  faRocketLaunch as faRegularRocketLaunch,
  faScissors as faRegularScissors,
  faSearch as faRegularSearch,
  faShareSquare as faRegularShareSquare,
  faShieldHalved as faRegularShieldHalved,
  faShop as faRegularShop,
  faSidebar as faRegularSidebar,
  faSignPost as faRegularSignPost,
  faSitemap as faRegularSitemap,
  faSpinner as faRegularSpinner,
  faSquare as faRegularSquare,
  faStar as faRegularStar,
  faSuitcaseRolling as faRegularSuitcaseRolling,
  faTable as faRegularTable,
  faTag as faRegularTag,
  faTags as faRegularTags,
  faTerminal as faRegularTerminal,
  faText as faRegularText,
  faThumbsUp as faRegularThumbsUp,
  faTimes as faRegularTimes,
  faTimesCircle as faRegularTimesCircle,
  faTrain as faRegularTrain,
  faTrash as faRegularTrash,
  faTrashCan as faRegularTrashCan,
  faTriangleExclamation as faRegularTriangleExclamation,
  faUnderline as faRegularUnderline,
  faUnlock as faRegularUnlock,
  faUpload as faRegularUpload,
  faUser as faRegularUser,
  faUserCircle as faRegularUserCircle,
  faUserPlus as faRegularUserPlus,
  faUserXmark as faRegularUserXmark,
  faUsers as faRegularUsers,
  faVirus as faRegularVirus,
  faVolume as faRegularVolume,
  faXmark as faRegularXmark,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faCloudArrowDown as faLightCloudArrowDown,
  faEnvelope as faLightEnvelope,
  faFile as faLightFile,
  faFileAudio as faLightFileAudio,
  faFileCode as faLightFileCode,
  faFileCsv as faLightFileCsv,
  faFileExcel as faLightFileExcel,
  faFileImage as faLightFileImage,
  faFileLines as faLightFileLines,
  faFilePdf as faLightFilePdf,
  faFilePowerpoint as faLightFilePowerpoint,
  faFileVideo as faLightFileVideo,
  faFileWord as faLightFileWord,
  faFileZipper as faLightFileZipper,
  faImage as faLightImage,
  faMobileScreenButton as faLightMobileScreenButton,
  faPaperclipVertical as faLightPaperclipVertical,
} from "@fortawesome/pro-light-svg-icons";
import {
  faChartSimple as faDuotoneChartSimple,
  faMedal as faDuotoneMedal,
  faUsers as faDuotoneUsers,
} from "@fortawesome/pro-duotone-svg-icons";

config.autoReplaceSvg = "nest";

library.add(
  faBrandsDailymotion,
  faBrandsDeviantart,
  faBrandsFacebook,
  faBrandsFlickr,
  faBrandsInstagram,
  faBrandsKickstarter,
  faBrandsMicrosoft,
  faBrandsSlideshare,
  faBrandsSoundcloud,
  faBrandsSpotify,
  faBrandsTwitter,
  faBrandsVimeo,
  faBrandsWebAwesome,
  faBrandsYoutube,
  faDuotoneChartSimple,
  faDuotoneMedal,
  faDuotoneUsers,
  faLightCloudArrowDown,
  faLightEnvelope,
  faLightFile,
  faLightFileAudio,
  faLightFileCode,
  faLightFileCsv,
  faLightFileExcel,
  faLightFileImage,
  faLightFileLines,
  faLightFilePdf,
  faLightFilePowerpoint,
  faLightFileVideo,
  faLightFileWord,
  faLightFileZipper,
  faLightImage,
  faLightMobileScreenButton,
  faLightPaperclipVertical,
  faRegularAlignCenter,
  faRegularAlignLeft,
  faRegularAlignRight,
  faRegularAngleLeft,
  faRegularAngleRight,
  faRegularArrowDownToBracket,
  faRegularArrowLeft,
  faRegularArrows,
  faRegularArrowsRepeat,
  faRegularArrowsUpDownLeftRight,
  faRegularBars,
  faRegularBell,
  faRegularBold,
  faRegularBolt,
  faRegularBookmark,
  faRegularBoxArchive,
  faRegularBullhorn,
  faRegularCalendar,
  faRegularCalendarDay,
  faRegularCalendarPlus,
  faRegularCalendarRange,
  faRegularCarSide,
  faRegularChartColumn,
  faRegularChartSimple,
  faRegularCheck,
  faRegularCheckCircle,
  faRegularCheckSquare,
  faRegularChevronDown,
  faRegularChevronUp,
  faRegularCircle,
  faRegularCircleCheck,
  faRegularCircleInfo,
  faRegularCircleNotch,
  faRegularCirclePlay,
  faRegularCirclePlus,
  faRegularCircleUser,
  faRegularClipboard,
  faRegularClipboardList,
  faRegularClock,
  faRegularClone,
  faRegularCloudDownload,
  faRegularCloudUpload,
  faRegularComment,
  faRegularCommentDots,
  faRegularCommentSlash,
  faRegularComments,
  faRegularCompass,
  faRegularComputerClassic,
  faRegularDesktop,
  faRegularEarthEurope,
  faRegularEdit,
  faRegularEllipsis,
  faRegularEllipsisH,
  faRegularEllipsisVertical,
  faRegularEnvelope,
  faRegularExchange,
  faRegularEye,
  faRegularFaceSmile,
  faRegularFile,
  faRegularFileCode,
  faRegularFileExcel,
  faRegularFilePowerpoint,
  faRegularFileText,
  faRegularFileWord,
  faRegularFiles,
  faRegularFilter,
  faRegularFlask,
  faRegularFloppyDisk,
  faRegularFolder,
  faRegularFolderOpen,
  faRegularGift,
  faRegularHand,
  faRegularHandshake,
  faRegularHeadphones,
  faRegularHouse,
  faRegularImage,
  faRegularInbox,
  faRegularItalic,
  faRegularKeyboard,
  faRegularLink,
  faRegularList,
  faRegularListUl,
  faRegularLocationDot,
  faRegularLock,
  faRegularMailbox,
  faRegularMapLocation,
  faRegularMapLocationDot,
  faRegularMessages,
  faRegularMinusCircle,
  faRegularMobile,
  faRegularNewspaper,
  faRegularPaperclipVertical,
  faRegularPenNib,
  faRegularPenToSquare,
  faRegularPencil,
  faRegularPencilSquare,
  faRegularPhone,
  faRegularPipe,
  faRegularPlus,
  faRegularPlusCircle,
  faRegularPlusSquare,
  faRegularPowerOff,
  faRegularPuzzlePiece,
  faRegularRocketLaunch,
  faRegularScissors,
  faRegularSearch,
  faRegularShareSquare,
  faRegularShieldHalved,
  faRegularShop,
  faRegularSidebar,
  faRegularSignPost,
  faRegularSitemap,
  faRegularSpinner,
  faRegularSquare,
  faRegularStar,
  faRegularSuitcaseRolling,
  faRegularTable,
  faRegularTag,
  faRegularTags,
  faRegularTerminal,
  faRegularText,
  faRegularThumbsUp,
  faRegularTimes,
  faRegularTimesCircle,
  faRegularTrain,
  faRegularTrash,
  faRegularTrashCan,
  faRegularTriangleExclamation,
  faRegularUnderline,
  faRegularUnlock,
  faRegularUpload,
  faRegularUser,
  faRegularUserCircle,
  faRegularUserPlus,
  faRegularUserXmark,
  faRegularUsers,
  faRegularVirus,
  faRegularVolume,
  faRegularXmark,
  faSolidAdjust,
  faSolidAlignJustify,
  faSolidAngleDoubleDown,
  faSolidAngleDoubleLeft,
  faSolidAngleDoubleRight,
  faSolidAngleDoubleUp,
  faSolidAngleLeft,
  faSolidAngleRight,
  faSolidArchive,
  faSolidArrowCircleUp,
  faSolidArrowDown,
  faSolidArrowLeft,
  faSolidArrowRight,
  faSolidArrows,
  faSolidArrowsUpDownLeftRight,
  faSolidAt,
  faSolidBan,
  faSolidBarChart,
  faSolidBars,
  faSolidBold,
  faSolidBook,
  faSolidBug,
  faSolidBullhorn,
  faSolidCalendar,
  faSolidCaretDown,
  faSolidCaretLeft,
  faSolidCaretRight,
  faSolidCertificate,
  faSolidCheck,
  faSolidCheckSquare,
  faSolidChevronCircleDown,
  faSolidChevronDown,
  faSolidChevronRight,
  faSolidChevronUp,
  faSolidCircle,
  faSolidCircleInfo,
  faSolidCirclePlus,
  faSolidCircleQuestion,
  faSolidClone,
  faSolidCloudDownload,
  faSolidCode,
  faSolidCodeFork,
  faSolidCoffee,
  faSolidCog,
  faSolidCogs,
  faSolidColumns,
  faSolidCompress,
  faSolidEllipsis,
  faSolidEllipsisH,
  faSolidEnvelope,
  faSolidExclamation,
  faSolidExpand,
  faSolidExternalLink,
  faSolidEye,
  faSolidEyeSlash,
  faSolidFile,
  faSolidFileCsv,
  faSolidFileExcel,
  faSolidFilter,
  faSolidFlag,
  faSolidFlagCheckered,
  faSolidFolder,
  faSolidFolderOpen,
  faSolidFont,
  faSolidGears,
  faSolidGlobe,
  faSolidGripDots,
  faSolidHashtag,
  faSolidHeader,
  faSolidHome,
  faSolidImage,
  faSolidInfoCircle,
  faSolidItalic,
  faSolidLink,
  faSolidLinkSlash,
  faSolidList,
  faSolidListAlt,
  faSolidListOl,
  faSolidLock,
  faSolidMailbox,
  faSolidMessageQuote,
  faSolidMessageXmark,
  faSolidPaperclip,
  faSolidPencil,
  faSolidPipe,
  faSolidPlay,
  faSolidPlus,
  faSolidPlusCircle,
  faSolidPrint,
  faSolidQuestion,
  faSolidQuestionCircle,
  faSolidQuoteLeft,
  faSolidRefresh,
  faSolidReply,
  faSolidReplyAll,
  faSolidRss,
  faSolidSave,
  faSolidSearch,
  faSolidShare,
  faSolidShield,
  faSolidSort,
  faSolidSortAsc,
  faSolidSortDesc,
  faSolidSortDown,
  faSolidSortNumericAsc,
  faSolidSortUp,
  faSolidSpaceShuttle,
  faSolidSpinner,
  faSolidSquare,
  faSolidSquareO,
  faSolidStar,
  faSolidStepBackward,
  faSolidStepForward,
  faSolidTag,
  faSolidTags,
  faSolidThumbsUp,
  faSolidThumbtack,
  faSolidTimes,
  faSolidTimesCircle,
  faSolidToggleOff,
  faSolidToggleOn,
  faSolidTrash,
  faSolidUnlock,
  faSolidUnlockAlt,
  faSolidUser,
  faSolidUserCircle,
  faSolidUserMinus,
  faSolidUserPlus,
  faSolidUserSecret,
  faSolidUserTimes,
  faSolidUserXmark,
  faSolidUsers,
  faSolidXmark,
);

dom.watch();
